import React, { useState, useEffect } from 'react';

interface ActionBarProps {
  selectAll: boolean;
  isIndeterminate: boolean;
  onUpdateSelectAll: (value: boolean) => void;
}

const ActionBar: React.FC<ActionBarProps> = ({ selectAll, isIndeterminate, onUpdateSelectAll }) => {
  const [currentSelectAll, setCurrentSelectAll] = useState(false);
  console.log(isIndeterminate, 'isIndeterminate');

  useEffect(() => {
    setCurrentSelectAll(selectAll);
  }, [selectAll]);

  const handleSelectAllChange = (checked: boolean) => {
    setCurrentSelectAll(checked);
    onUpdateSelectAll(checked);
  };

  return (
    <div className="px-4 absolute bottom-0 left-0 right-0 rounded-lg">
      <div>
        <div className="flex items-center justify-between p-3 bg-white">
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={currentSelectAll}
              onChange={e => handleSelectAllChange(e.target.checked)}
              className="w-4 h-4"
              ref={input => {
                if (input) {
                  input.indeterminate = isIndeterminate;
                }
              }}
            />
            <span className="text-sm text-[#1F1F1F]">全选</span>
          </div>
          <div className="flex gap-2">
            <button className="bg-gradient-to-r from-[#5D2BC7] to-[#A644CA] text-white px-2 py-1 rounded text-sm shadow-sm">
              发送
            </button>
            <button className="border border-[#5959EB] text-[#5959EB] px-2 py-1 rounded text-sm">
              导出
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
